import dayjs, { Dayjs } from "dayjs"
import dayjs_plugin_utc from "dayjs/plugin/utc"

import { getLastNDaysExcludingToday } from "utils/dateUtils"

dayjs.extend(dayjs_plugin_utc)

export const dropDownOptions = [
  {
    value: "yesterday",
    label: "Yesterday",
  },
  {
    value: "last3Days",
    label: "Last 3 Days",
  },
  {
    value: "last7Days",
    label: "Last 7 Days",
  },
  {
    value: "last30Days",
    label: "Last 30 Days",
  },
  {
    value: "custom",
    label: "Custom",
  },
]

const setDateParam = (startDate: Dayjs, endDate: Dayjs) => {
  const startDateString = startDate.format("YYYY-MM-DD")
  const endDateString = endDate.format("YYYY-MM-DD")

  return {
    startDateTime: startDate,
    startDateString,
    endDateString,
  }
}

export const getInstalledDevicesDateRangeParams = (
  value: string | number | boolean,
  dateRange: [Dayjs, Dayjs] | null,
) => {
  if (value === "yesterday") {
    const yesterdayStart = dayjs().utc().subtract(1, "day")

    return { ...setDateParam(yesterdayStart, yesterdayStart), daysCount: 1 }
  }

  if (value === "last3Days") {
    const { startDate, endDate } = getLastNDaysExcludingToday(3)
    return { ...setDateParam(startDate, endDate), daysCount: 3 }
  }

  if (value === "last7Days") {
    const { startDate, endDate } = getLastNDaysExcludingToday(7)
    return { ...setDateParam(startDate, endDate), daysCount: 7 }
  }

  if (value === "last30Days") {
    const { startDate, endDate } = getLastNDaysExcludingToday(30)
    return { ...setDateParam(startDate, endDate), daysCount: 30 }
  }

  const dateRangeStart = dateRange?.[0] || dayjs().utc().startOf("day")
  const dateRangeEnd = dateRange?.[1] || dayjs().utc().startOf("day")

  const daysCount = dateRangeEnd.diff(dateRange?.[0], "days") + 1

  return {
    startDateTime: dateRangeStart.startOf("day"),
    startDateString: dateRangeStart.startOf("day")?.format("YYYY-MM-DD"),
    endDateString: dateRangeEnd.startOf("day")?.format("YYYY-MM-DD"),
    daysCount,
  }
}
